import {observer} from "mobx-react";
import {
  Button,
  Drawer,
  Tabs,
  Timeline,
  Spin,
  Radio,
  Space,
  Popconfirm,
  Form,
  Alert,
  Select,
  Input, message, Tooltip
} from "antd";
import FakeTable from "../../components/FakeTable";
import React, {useEffect, useState} from "react";
import MyTabs from "../../components/MyTabs";
import {callAndReload, callWithCatch, genderedAge, idNameToOption, pp, tourneyUrl} from "../../utils";
import {PlayerChanger, PlayerChangerButton, PlayerUnWithdrawer, PlayerWithdrawer} from "../tourney/Registration";
import {PlayerActions as PlayerActionsComponent, AdminPlayerActions} from "../tourney/PlayerActions";
import {observable} from "mobx";
import User from "../../components/User";
import {FormModalBtn, NiceModalForm} from "../../components/Modals";
import FormSelector from "../../components/FormSelector";
import axios from "axios";
import NiceModal from "@ebay/nice-modal-react";
import {EditPlayerDupr} from "../../components/DuprSetter";
import duprRating from "../allstate/DuprRating";
import Tourney from "../tourney/Tourney";
import {useEffectOnce} from "react-use";
import CardTable from "../tourney/CardTable";
import {Showable} from "../../components/Switcher";
import ActionsBtn from "../../components/ActionsBtn";
import {CreditCardTwoTone} from "@ant-design/icons";
import Spacer from "../../components/Spacer";
import {openStats} from "../exclusive_tt/Stats";
import _ from "lodash";
import Device from "@/components/Device.js";

export const PlayerStore = observable({
  loading: false,
  player: null,
  activities: [],
  activitiesLoading: false,
  mainStore: null,

  open: (id) => {
    PlayerStore.loading = true;
    callWithCatch({
      url: "/players/" + id + "?include_activities=true",
      method: 'get',
      onSuccess: data => {
        PlayerStore.player = data.player;
        PlayerStore.activities = data.activities || [];
        PlayerStore.loading = false;
      },
      onErr: () => PlayerStore.loading = false
    })
  },
  reload: () => {
    if (User.viewer)
      return;

    PlayerStore.player && PlayerStore.open(PlayerStore.player.id);
    PlayerStore.mainStore?.reload();
    PlayerStore.mainStore?.triggerRefresh?.('reg_change');
  },
  close: () => LoginStore.view = null
});


let DivisionChanger = observer(({r}) => {
  let [divs, setDivs] = useState();

  useEffect(() => {
    let load = async () => {
      let data = (await axios.get(`/registrations/${r.id}/edit`)).data;
      setDivs(data.divisions);
    };
    load();
  }, [r]);

  let onSave = async (params) => {
    await callWithCatch({
      url: `/registrations/${r.id}`,
      method: 'put',
      params: params,
      onSuccess: () => PlayerStore.reload()
    })
  }

  return <FormModalBtn asLink
                       zIndex={1005}
                       savedMsg="none"
                       onSave={onSave}
                       initialValues={{division_id: r.to_id}}
                       title="Change Division"
  >
    <Spin spinning={!divs}>
      {divs && <FormSelector width="300px" label="Change to" name="division_id" options={divs.map(d => [d.id, d.name])} />}
    </Spin>
  </FormModalBtn>
});

export const PlayerWithdrawAll = observer(({pl, ...props}) => {
  let withdraw = () => {
    callAndReload({
      url: `/players/${pl.id}`,
      method: 'put',
      params: { withdraw: true },
    })
  }

  let btn = <Button type="">Withdraw From Tournament</Button>;

  return <Popconfirm
    title="Are you sure?"
    onConfirm={withdraw}
  >
    {btn}
  </Popconfirm>
})

export const ReplacePlayer = NiceModal.create(observer(({pl, r}) => {
  const [data, setData] = useState(false);

  let load = () => {
    callWithCatch({
      url: `/registrations/${r.id}/edit`,
      method: 'get',
      onSuccess: data => setData(data),
    })
  }

  let replace = async (params) => {
    await callWithCatch({
      url: `/registrations/${r.id}`,
      method: 'put',
      params,
      reload: true,
    })
  }

  useEffectOnce(load);

  return <NiceModalForm width={400} okText="Replace" onSave={replace} title={"Replace " + pl.name} zIndex={1010}>
      <FormSelector showSearch
                    name="replace_with_player_id"
                    autoComplete="new-state"
                    loading={!data}
                    label="Replace With" width="300px"
                    filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())}
                    options={data ? data.single_players.map(pl => idNameToOption(pl)) : []} />

    { data && !data.single_players.length && <Alert type="warning" message="No Players Needing a Team" />}
  </NiceModalForm>
}));

export const AddPlayerDivision = NiceModal.create(observer(({pl}) => {
  const [tevents, setTevents] = useState();

  let load = () => {
    callWithCatch({
      url: `/players/${pl.id}`,
      method: 'get',
      onSuccess: data => {
        setTevents(data.player.add_to_divs)
      }
    })
  }

  useEffectOnce(load);

  let add = (params) => {
    if (!params.division_ids || _.every(params.division_ids, d => d === 0)) {
      alert("can't add without division");
      return;
    }

    return callWithCatch({
      url: `/players/${pl.id}/add_divisions`,
      method: 'post',
      params,
      onSuccess: () => {
        NiceModal.remove(AddPlayerDivision);
        PlayerStore.open(pl.id);
        PlayerStore.mainStore?.reload();
      }
    })
  }

  let name = pl.name;

  return <NiceModalForm width={400} okText="Add" onSave={add} title={name + ": Add Events"} zIndex={1010}>
    { !Tourney.njp && !Tourney.no_pay && <Form.Item name="payment_status" label="Need to Pay?" rules={[{ required: true}]}>
      <Radio.Group>
        <Radio value="free">No (Comped/Free)</Radio>
        <Radio value="need_to_pay">Yes</Radio>
      </Radio.Group>
    </Form.Item> }
    <Spin spinning={!tevents}>
      { tevents && tevents.map((ev, i) => <FormSelector width={200} notRequired={true} name={["division_ids", i]} label={ev.name} options={[[0, "No"], ...ev.divisions.map(d => [d.id, d.name])]} />)}
      { tevents && !tevents.length && <Alert message="No events to add" type="error" />}
    </Spin>
  </NiceModalForm>
}));

let PaymentStatusSelector = ({r}) => {
  const [loading, setLoading] = useState(false);

  let setPaymentStatus = payment_status => {
    callWithCatch({
      setLoading,
      url: `/registrations/${r.id}`,
      method: 'put',
      params: { payment_status },
      onSuccess: () => r.payment_status = payment_status,
    })
  }

  let select =  <Select style={{width: "135px"}} onChange={setPaymentStatus}
                 loading={loading}
                 options={[
                   {value: "refunded", label: "Refunded"},
                   {value: "no_refund", label: "No Refund"},
                   {value: "need_refund", label: "Needs Refund"},
                   {value: "none", label: "Refund?"},
                 ]}
                 value={r.payment_status}
  />;

  let color = {
    none: '#64748b',
    need_refund: '#64748b',
    refunded: '#22c55e',
    no_refund: '#ef4444',
  }[r.payment_status]

  return <Space>
    {select}
    <CreditCardTwoTone style={{fontSize: "24px"}} twoToneColor={color}/>
  </Space>

}

let EditPlayer = NiceModal.create(observer(({ pl }) => {
  let onSave = async (params) => {
    await callWithCatch({
      url: `/players/${pl.id}`,
      params,
      method: 'put',
      onSuccess: data => {
        message.success("Saved!");
        NiceModal.remove(EditPlayer);
        PlayerStore.reload();
      }
    });
  }

  let pds = gon.tournament.settings.player_details;
  let withAgeDetail = !pds || _.includes(pds, "age");

  return <NiceModalForm top width={320} onSave={onSave} title={"Edit " + pl.name} okText="Save" initialValues={pl} zIndex={1005}>
    <div>
      <Form.Item name="gender" label="Gender" rules={[{required: true}]}>
        <Radio.Group>
          <Radio value='male'>Male</Radio>
          <Radio value='female'>Female</Radio>
        </Radio.Group>
      </Form.Item>
      <div className="columns-2">
        <Form.Item name="fname" label="First Name" rules={[{required: true}]}>
          <Input autoFocus />
        </Form.Item>
        <Form.Item name="lname" label="Last Name" rules={[{required: true}]}>
          <Input />
        </Form.Item>
      </div>
      <Form.Item label="Age" name="age" rules={[{required: withAgeDetail, pattern: /^\d+$/, message: "Invalid Age"}]}>
        <Input style={{width: "50px"}}/>
      </Form.Item>
      <Form.Item name="phone" label="Phone">
        <Input />
      </Form.Item>
      <Form.Item name="email" label="Email">
        <Input />
      </Form.Item>
    </div>
  </NiceModalForm>
}));

const DuprSection = observer(({ pl }) => {
  if (!Tourney.dupr) return null;

  let duprUpdated = () => {
    PlayerStore.reload();
  }

  let ratingViewFor = (source, type) => {
    let r = _.find(pl.rating, { source, type })
    return duprRating({r: r?.rating});
  }

  // Get doubles rating: prefer rating array, fall back to wpr
  let doublesR = _.find(pl.rating, { source: 'dupr', type: 'doubles' })?.rating;
  let doublesRating = duprRating({r: doublesR || pl.wpr});
  let singlesRating = ratingViewFor('dupr', 'singles');

  // Only NJP can edit DUPR ID
  let duprId = Tourney.njp
    ? <a onClick={() => NiceModal.show(EditPlayerDupr, {pl, load: duprUpdated})}>{pl.dupr_xid || "Set"}</a>
    : pl.dupr_xid;

  let data = [
    ["ID", duprId],
    ["Doubles Rating", doublesRating],
  ];

  // Only show singles if available (from rating array)
  if (Tourney.njp) {
    data.push(["Singles Rating", singlesRating]);
  }

  return <div>
    <h2>DUPR</h2>
    <FakeTable labelWidth="200px" cs="ant-table-small" data={data} />
  </div>
});

const Details = observer(({ pl }) => {
  let data = [
    ["Phone", pl.phone],
    ["Email", pl.email],
  ]

  if (pl.birthdate_view) {
    data.push(["Birthdate", pl.birthdate_view]);
  }

  if (Tourney.njp)
    data.unshift(["Contact Name", pl.contact_name])

  return <div className="space-y-8">
    {!pl.user_id && <Button type="primary" onClick={() => NiceModal.show(EditPlayer, { pl })}>Edit</Button>}
    <div>
      <h2>Player Info</h2>
      <FakeTable labelWidth="200px" cs="ant-table-small" data={data} />
    </div>
  </div>
});

export default observer(({store}) => {
  let pl = PlayerStore.player;

  let name = pl?.name;
  let title=null;
  let inner=<Spin/>;

  if (pl && !PlayerStore.loading) {
    let regs = pl.registrations;

    let njp = Tourney.njp;

    let divRegs = _.filter(regs, r => r.to_type === "Division");
    let by_status = _.groupBy(divRegs, r => {
      if (r.withdrawn)
        return 'withdrawn';

      if (r.status === "waitlist")
        return 'waitlist'

      return 'play'
    })

    let playRegs = by_status.play;
    let withdrawnRegs = by_status.withdrawn;
    let waitlistRegs = by_status.waitlist;

    title = <Spacer l={name} r={genderedAge(pl)} />

    let closeAndOpenStats = () => {
      PlayerStore.player = null;
      openStats(null, pl.id);
    }

    inner = <div>
      <MyTabs defaultActiveKey="event_reg" tabBarExtraContent={<a onClick={closeAndOpenStats}>Stats</a>}>
        <Tabs.TabPane tab="Registration" key="reg" className="space-y-8">
          { !Tourney.joola && gon.tevents.length > 1 && !Tourney.milp && <Space>
            <Button onClick={() => NiceModal.show(AddPlayerDivision, {pl})}>Add Events</Button>
            { _.some(regs, r => !r.withdrawn) && <PlayerWithdrawAll pl={pl} regs={regs} /> }
          </Space> }

          <DuprSection pl={pl} />

          <CardTable small cardProps={{bordered: false}} title="Registered to Events" objs={playRegs} hidenOnEmpty tds={r => {
            let action, status;

            if (User.admin && gon.tournament.status !== "done" && r.actions) {
                action = <AdminPlayerActions r={r} pl={pl} />
            }

            // Show player actions if player is viewing their own profile and not an admin
            if (!User.admin && gon.user && gon.user.id === pl.user_id && r.player_actions) {
              action = <PlayerActionsComponent r={r} />
            }

            let title = <div className="space-y-2">
              <div className="flex items-center gap-2">
                <div className="font-bold flex-1">{r.division_name}</div>
                <div className="flex-shrink-0">{action}</div>
              </div>
              <div className="text-gray-500">{r.status_view}</div>
            </div>

            return [title, status]
          }} />

          <CardTable small cardProps={{bordered: false}} title="Waitlisted in Events" objs={waitlistRegs} hidenOnEmpty tds={r => {
            let waitlistActions = null;
            if (User.admin && gon.tournament.status !== "done") {
              let removeFromWaitlist = () => {
                callWithCatch({
                  url: `/registrations/${r.id}`,
                  method: 'put',
                  params: { unwaitlist: true },
                  onSuccess: PlayerStore.reload
                })
              }
              
              let addToPending = () => {
                callWithCatch({
                  url: `/registrations/${r.id}`,
                  method: 'put',
                  params: { to_pending: true },
                  onSuccess: PlayerStore.reload
                })
              }
              
              waitlistActions = <ActionsBtn actions={[
                ["Register to Event", addToPending],
                ["Delete Waitlist Entry", removeFromWaitlist],
              ]} />
            }
            
            let waitlistInfo = <div>
              <div>{r.division_name}</div>
              {r.waitlisted_at && <div className="text-gray-500 text-sm">Waitlisted at: {new Date(r.waitlisted_at).toLocaleString()}</div>}
            </div>
            
            return [waitlistInfo, waitlistActions]
          }} />

          <CardTable small cardProps={{bordered: false}} title="Withdrawn from Events" objs={withdrawnRegs} hidenOnEmpty tds={r => {
            let action = null;
            
            if (User.admin && r.actions) {
              action = <Space>{r.actions.map(a => {
                if (a === "unwithdraw")
                  return <PlayerUnWithdrawer key={a} r={r} />
                
                return a
              })}</Space>
            }

            let payment;
            if (r.payment_status === "free")
              payment = "Was Free"
            else if (r.payment_status)
              payment = <PaymentStatusSelector r={r} />

            if (njp || Tourney.no_pay)
              return [r.division_name, action]

            if (!Tourney.excel)
              return [<div className="">
                <div>{r.division_name}</div>
              </div>]

            return [
              <div className="">
                <div>{r.division_name}</div>
              </div>,
              payment,
              action
            ]
          }}/>
          { User.admin && !!pl.payment_links.length && Tourney.excel && <div className="pt-8 px-2 space-y-4">
            <div className="font-bold">Payments</div>
            {pl.payment_links.map(pi => <div key={pi}><a href={pi[1]} target="_blank">{pi[0]}</a></div>)}
            {/*{pl.refund_amount ? <div>To Refund Amount: ${pl.refund_amount}</div> : null}*/}
          </div>}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Details" key="details">
          <Details pl={pl} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Activity Log" key="log">
          <ActivityLog activities={PlayerStore.activities} loading={PlayerStore.activitiesLoading} />
        </Tabs.TabPane>
      </MyTabs>
    </div>
  }

  return <Drawer onClose={() => PlayerStore.player = null} title={title} placement="right" visible={name} zIndex={1002} width={!Device.xs && 500}>
    {inner}
  </Drawer>
});

const ActivityLog = observer(({activities, loading}) => {
  if (loading) {
    return <div className="flex justify-center p-4"><Spin /></div>;
  }

  if (!activities.length) {
    return <div className="p-4 text-gray-500">No activity recorded yet.</div>;
  }

  return (
    <Timeline className="p-4">
      {activities.map(activity => (
        <Timeline.Item key={activity.id}>
          <div className="mb-2">
            <div className="font-medium">{activity.msg}</div>
            <div className="text-sm text-gray-500">
              {activity.user_name && `by ${activity.user_name} • `}
              <Tooltip title={activity.formatted_date}>
                <span className="cursor-help">{activity.time_ago}</span>
              </Tooltip>
            </div>
          </div>
        </Timeline.Item>
      ))}
    </Timeline>
  );
});

